jQuery(document).ready(function(){
    mobileScaling();
    jQuery('.secondStep, .thirdStep, .frequency, .subscriptionTotals, .bottomLinks, .preSecondStep').hide();
    
    jQuery('.firstStep .oneThird').click(function(){
        var parent = jQuery(this).parent(),
            missed = jQuery(this).hasClass('checked'),
            current = jQuery(this);

        jQuery(parent).find('.oneThird').removeClass('checked');
        jQuery(this).addClass('checked');
        mobileHider();  
        jQuery('#beanIndex').val(jQuery( ".firstStep .oneThird" ).index( this ));
      
        if(jQuery( ".firstStep .oneThird" ).index( this ) == 1) {
            var visibilityIndex = 1;

            jQuery('.Ground').hide();
            jQuery('.pods').hide();
            jQuery('.Whole, #viewMoreLink').show();
            jQuery('.preSecondStep').hide();
            jQuery('.Whole').each(function(index){
                if(index >= 8) {
                    jQuery(this).hide();
                    jQuery(this).addClass('hiddenMore');
                }
            })
        } else if(jQuery( ".firstStep .oneThird" ).index( this ) == 0) {
            jQuery('.Whole, #viewMoreLink').hide(); 
            jQuery('.Ground').show();
            jQuery('.pods').hide();
            jQuery('.preSecondStep').hide();
        } else {
            jQuery('.Whole, #viewMoreLink').hide(); 
            jQuery('.Ground').hide();
            jQuery('.preSecondStep').show();
            jQuery('html, body').animate({ scrollTop: $('.preSecondStep .how-it-works').offset().top }, 'slow');		  
        }

        if(jQuery( ".firstStep .oneThird" ).index( this ) == 0 || jQuery( ".firstStep .oneThird" ).index( this ) == 1) {
            if(jQuery('.secondStep').is(":hidden") || !missed) {
                jQuery('.secondStep').show();
                jQuery('html, body').animate({ scrollTop: $('.secondStep .how-it-works').offset().top }, 'slow');
            }
        }
        jQuery('.firstBlock .blockLabelBot').text(jQuery(this).find('h4').text());
    })
    
    jQuery('.preSecondStep .oneThird').click(function(){
        var parent = jQuery(this).parent(),
            missed = jQuery(this).hasClass('checked'),
            current = jQuery(this);

        jQuery(parent).find('.oneThird').removeClass('checked');
        jQuery(this).addClass('checked');
        jQuery('.pods').hide();
        jQuery('.pods_36').hide();

        if(jQuery( ".preSecondStep .oneThird" ).index( this ) == 0) {
            jQuery('.pods').show();
            jQuery('.pods_36').hide();	
        } else {
            jQuery('.pods_36').show();
        }
  
        jQuery(this).addClass('checked');
        if(jQuery('.secondStep').is(":hidden") || !missed) {
            jQuery('.secondStep').show();
            jQuery('html, body').animate({ scrollTop: $('.secondStep .how-it-works').offset().top }, 'slow');
        }
        //jQuery('.firstBlock .blockLabelBot').text(jQuery(this).find('h4').text());
    })
    
    jQuery('.secondStep .oneFifth').click(function(){
        var parent = jQuery(this).parent(),
            missed = jQuery(this).hasClass('checked'),
            current = jQuery(this),
            total = parseFloat(jQuery('#coffeePrice').val()) * jQuery( "#qtyIndex" ).val();

        jQuery(parent).find('.oneFifth').removeClass('checked');
        jQuery(this).addClass('checked');
        mobileHider();
      
        saveSubVar(jQuery( ".oneFifth" ).index( this ), jQuery(this).attr('data-id'));
  
        total = total.toFixed(2);
        jQuery('.forthBlock .rightSumBlock p').text('$'+ total);
  
        if(jQuery(this).hasClass('bigQty')) {
            var qty = 1,
                total = parseFloat(jQuery('#coffeePrice').val()) * qty;

            jQuery('#qtyIndex').val(qty);
            total = total.toFixed(2);     
            cupsCounter('3 bags (36oz)');
            jQuery('.forthBlock .rightSumBlock p').text('$'+ total);
            jQuery('.frequency').show();
            jQuery('html, body').animate({ scrollTop: $('.frequency .how-it-works').offset().top }, 'slow');

            jQuery('.secondBlock .blockLabelMiddle').text('3 bags (36oz)');
            jQuery('.secondBlock .blockLabelBot').text('About 90 cups per shipment');        
        } else { 
            if(jQuery('.thirdStep').is(":hidden") || !missed) {
                jQuery('.thirdStep').show(); 
                jQuery('html, body').animate({ scrollTop: $('.thirdStep .how-it-works').offset().top }, 'slow');
            }
        }
      
        /* rounds cup calculation*/
        if(jQuery(this).hasClass('pods')) {
            jQuery('.thirdStep .oneForth:nth-child(1) p:first').html('');
            jQuery('.thirdStep .oneForth:nth-child(2) p:first').html('');
            jQuery('.thirdStep .oneForth:nth-child(3) p:first').html('');
            jQuery('.thirdStep .oneForth:nth-child(4) p:first').html('');
          
            jQuery('.thirdStep .oneForth .roundsImg').show();
            jQuery('.thirdStep .oneForth .notRoundsImg').hide();
        
            if(jQuery(this).hasClass('pods_36')) {
                jQuery('.thirdStep .oneForth:nth-child(1) h4').html('1 box, 36 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(2) h4').html('2 boxes, 72 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(3) h4').html('3 boxes, 108 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(4) h4').html('4 boxes, 144 Single Serve Pods'); 
                
            } else {
                jQuery('.thirdStep .oneForth:nth-child(1) h4').html('1 box, 12 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(2) h4').html('2 boxes, 24 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(3) h4').html('3 boxes, 36 Single Serve Pods');
                jQuery('.thirdStep .oneForth:nth-child(4) h4').html('4 boxes, 48 Single Serve Pods'); 
            }
          
            jQuery('.thirdStep .how-it-works p').html('How many boxes per shipment?');
        } else {
          
            jQuery('.thirdStep .oneForth:nth-child(1) p:first').html('About 30 cups per shipment');
            jQuery('.thirdStep .oneForth:nth-child(2) p:first').html('About 60 cups per shipment');
            jQuery('.thirdStep .oneForth:nth-child(3) p:first').html('About 90 cups per shipment');
            jQuery('.thirdStep .oneForth:nth-child(4) p:first').html('About 120 cups per shipment');
          
            jQuery('.thirdStep .oneForth .roundsImg').hide();
            jQuery('.thirdStep .oneForth .notRoundsImg').show();         
          
            jQuery('.thirdStep .oneForth:nth-child(1) h4').html('1 Bag (12oz)');
            jQuery('.thirdStep .oneForth:nth-child(2) h4').html('2 bags (24oz)');
            jQuery('.thirdStep .oneForth:nth-child(3) h4').html('3 bags (36oz)');
            jQuery('.thirdStep .oneForth:nth-child(4) h4').html('4 bags (48oz)');
            jQuery('.thirdStep .how-it-works p').html('How many bags per shipment?');
        }
      
        jQuery('.firstBlock .blockLabelMiddle').text(jQuery(this).find('h4').text());
    })
  
    jQuery('.thirdStep .oneForth').click(function(){
        var parent = jQuery(this).parent(),
            missed = jQuery(this).hasClass('checked'),
            current = jQuery(this),
            qty = jQuery( ".thirdStep .oneForth" ).index( this ) + 1;

        jQuery(parent).find('.oneForth').removeClass('checked');
        jQuery(this).addClass('checked');
        mobileHider();
  
        jQuery('#qtyIndex').val(qty);
      
        var total = parseFloat(jQuery('#coffeePrice').val()) * qty;
        total = total.toFixed(2);     
      
        jQuery('.forthBlock .rightSumBlock p').text('$'+ total);
      
        if(jQuery('.frequency').is(":hidden") || !missed) {
            jQuery('.frequency').show();
            jQuery('html, body').animate({ scrollTop: $('.frequency .how-it-works').offset().top }, 'slow');
        }
        jQuery('.secondBlock .blockLabelMiddle').text(jQuery(this).find('h4').text());
        jQuery('.secondBlock .blockLabelBot').text(jQuery(this).find('p:eq( 0 )').text());
        cupsCounter(jQuery(this).find('h4').text());
        
        if(!jQuery('.subscriptionTotals').is(":hidden")) {
            showMealsDonation();		
        }
    })
    
    jQuery('.frequency .oneForth').click(function(){
        var parent = jQuery(this).parent(),
            missed = jQuery(this).hasClass('checked'),
            current = jQuery(this);
        jQuery(parent).find('.oneForth').removeClass('checked');
        jQuery(this).addClass('checked');
        mobileHider();
        jQuery('#freqIndex').val(jQuery( ".frequency .oneForth" ).index( this ));
        if(jQuery('.subscriptionTotals').is(":hidden") || !missed) {      
            jQuery('.subscriptionTotals, .bottomLinks').show();
            jQuery('html, body').animate({ scrollTop: $('.subscriptionTotals').offset().top }, 'slow');
        }
        
        showMealsDonation();	
          
        jQuery('.thirdBlock .blockLabelMiddle').text(jQuery(this).find('h4').text());
        var date = setNextShipDate(jQuery(this).find('h4').text());
        jQuery('.thirdBlock .blockLabelBot b').text(date);
  
    })
    
    jQuery('#viewMoreLink').click(function(e){
        e.preventDefault();
        jQuery('.hiddenMore').show();
        jQuery(this).hide();
        jQuery('.pods').hide();
    })
    
    
    jQuery('.firstBlock .rightSumBlock').click(function(){
        jQuery('html, body').animate({ scrollTop: $('.secondStep').offset().top }, 'slow');
    })
    
    jQuery('.secondBlock .rightSumBlock').click(function(){
        jQuery('html, body').animate({ scrollTop: $('.thirdStep').offset().top }, 'slow');
    })    
    
    jQuery('.thirdBlock .rightSumBlock').click(function(){
        jQuery('html, body').animate({ scrollTop: $('.frequency').offset().top }, 'slow');
    })
    
    
    jQuery('.mobile-nav--open').click(function(){
        if(jQuery(this).attr('aria-expanded') === "true" ) {
            jQuery('#PageContainer').addClass('navFix');
            jQuery('.rectangle').addClass('navRecFix');
        } else {
            jQuery('#PageContainer').removeClass('navFix');
            jQuery('.rectangle').removeClass('navRecFix');       
        }
  
    });
    
    
    jQuery('body').on( "click", '.firstStep .checked .editButton', function(){
        showFirstStep()
    })
  
    jQuery('body').on( "click",'.secondStep .checked .editButton',function(){
        showSecondStep();
    })
    
    
    jQuery('body').on( "click",'.thirdStep .checked .editButton',function(){
        showThirdStep();
    })
    
    jQuery('body').on( "click",'.frequency .checked .editButton',function(){
        showForthStep();
    })

    $('.continueCheckoutLink').click(function(e){
        e.preventDefault();
        var freq = '',
            freqType = '',
            option = '';
  
        if(jQuery('#freqIndex').val() == 0) {
            freq = 1;
            freqType = 'Weeks';
        }
  
        if(jQuery('#freqIndex').val() == 1) {
            freq = 2;
            freqType = 'Weeks';
        }
    
        if(jQuery('#freqIndex').val() == 2) {
            freq = 4;
            freqType = 'Weeks';
        }
    
        if(jQuery('#freqIndex').val() == 3) {
            freq = 8;
            freqType = 'Weeks';
        }  
    
        if(jQuery('#beanIndex').val() == 1) {
            option = 'Whole Bean';
        } else if(jQuery('#beanIndex').val() == 2) {
            option = 'Pods';
        } else {
            option = 'Ground Bean';
        }
  
        addItemToCart(jQuery('#subId').val() , jQuery('#qtyIndex').val(), freq, freqType,option);
    })
  
})
  
function showFirstStep() {
    if($(window).width() < 981 ) {
        jQuery('.firstStep .checked').removeClass('checked');
        jQuery('.firstStep .oneThird').each(function(){ 
            jQuery(this).show();
        })
    }
}

function showSecondStep() {
    if($(window).width() < 981 ) {
        jQuery('.secondStep .checked').removeClass('checked');
        jQuery('.secondStep .oneFifth').each(function(){ 
            jQuery(this).show();
        }) 
    }
}
  
function showThirdStep() {
    if($(window).width() < 981 ) {
        jQuery('.thirdStep .checked').removeClass('checked');
        jQuery('.thirdStep .oneForth').each(function(){ 
            jQuery(this).show();
        }) 
    }
}
  
function showForthStep() {
    if($(window).width() < 981 ) {
        jQuery('.frequency .checked').removeClass('checked');
        jQuery('.frequency .oneForth').each(function(){ 
            jQuery(this).show();
        }) 
    }
}
  
function setNextShipDate(text) {
    var date = new Date(),
        dateText;

        switch (text) {
            case 'Every 2 weeks':
                date.setDate(date.getDate() + 14);
                break;
            case 'Every week':
                date.setDate(date.getDate() + 7);
                break;
            case 'Every month':
                date.setDate(date.getDate() + 30);
                break;
            case 'Every 2 months':
                date.setDate(date.getDate() + 60);
                break;
        }

    dateText = date.toLocaleString("en-us", { month: "long" })+' '+date.getDate();
    return dateText;
}
  
function cupsCounter(amount) {
  
    if(amount == '1 Bag (12 0z)') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 30 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 15 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 7 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 3 cups / week');
    }
    
    if(amount == '2 bags (24oz)') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 60 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 30 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 15 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 7 cups / week');
    }
    
    if(amount == '3 bags (36oz)') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 90 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 45 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 23 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 12 cups / week');
    }

    if(amount == '4 bags (48oz)') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 180 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 90 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 45 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 23 cups / week');
    }
    
    if(amount == '1 box, 12 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 12 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 6 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 3 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 2 cups / week');
    }
    
    if(amount == '2 boxes, 24 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 24 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 12 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 6 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 3 cups / week');
    }
    
    if(amount == '3 boxes, 36 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 36 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 18 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 9 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 4 cups / week');
    }

    if(amount == '4 boxes, 48 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 48 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 24 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 12 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 6 cups / week');
    } 
  
    if(amount == '1 box, 36 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 36 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 18 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 9 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 4 cups / week');
    }
    
    if(amount == '2 boxes, 72 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 72 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 36 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 18 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 9 cups / week');
    }
    
    if(amount == '3 boxes, 108 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 108 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 54 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 27 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 13 cups / week');
    }
    if(amount == '4 boxes, 144 Single Serve Pods') {
        jQuery('.frequency .oneForth:eq( 0 ) p:eq( 0 )').text('About 144 cups / week');
        jQuery('.frequency .oneForth:eq( 1 ) p:eq( 0 )').text('About 72 cups / week');
        jQuery('.frequency .oneForth:eq( 2 ) p:eq( 0 )').text('About 36 cups / week');
        jQuery('.frequency .oneForth:eq( 3 ) p:eq( 0 )').text('About 18 cups / week');
    }	
    
}
  
function mobileScaling() {
    
    if($(window).width() < 981 ) {
        jQuery('body').addClass('mobile');
        jQuery('.search-icon').hide();
        jQuery("#shopify-section-header .js-mobile-nav-toggle").prependTo(".rectangle");
        jQuery("#shopify-section-header .mobile-nav-wrapper").prependTo(".rectangle"); 
        
        jQuery("#shopify-section-header .site-header__cart").appendTo(".rectangle");
    }
      
}
  
  
function mobileHider() {
    if($(window).width() < 981 ) {
      
        if(jQuery('.firstStep .oneThird').hasClass('checked')) { 
            jQuery('.firstStep .oneThird').each(function(){
                if(!jQuery(this).hasClass('checked')) {
                    jQuery(this).hide(); 
                }
            });
        }
      
        if(jQuery('.secondStep .oneFifth').hasClass('checked')) {                                     
            jQuery('.secondStep .oneFifth').each(function(){
                if(!jQuery(this).hasClass('checked')) {
                    jQuery(this).hide(); 
                }
            });
        }  
      
        if(jQuery('.thirdStep .oneForth').hasClass('checked')) { 
            jQuery('.thirdStep .oneForth').each(function(){
                if(!jQuery(this).hasClass('checked')) {
                    jQuery(this).hide(); 
                }
            });
        }  
  
        if(jQuery('.frequency .oneForth').hasClass('checked')) {       
            jQuery('.frequency .oneForth').each(function(){
                if(!jQuery(this).hasClass('checked')) {
                    jQuery(this).hide(); 
                }
            }); 
        }
    } 
}
  
function saveSubVar(productPosition, pId) { 
    
    var arrayCollection = [
            ['709531001','606544969'], // morningWalk
            ['709535517','606552281'], //paper-slippers
            ['9209875141','9209841925'], //sit-stay 
            ['742416185','606552921'], //alpha-blend
            ['5322845454377','5322845421609'], //hush-puppy
            ['801484845','614537073'], //peru-light
            ['','5317533466665'], //explorers origin      
            ['4321970061353','4321942241321'], //blend starter kit
            ['','4885122908201'], //PAPUA NEW GUINEA
            ['','906512541'], //COLOMBIAN  
            ['','4885095776297'], //MEXICAN CHIAPAS
            ['','614539153'], //SINGLE ORIGIN PERU
            ['','4096213155881'], //ETHIOPIAN YIRGACHEFFE       
        ],
        priceCollection = ['14.99','13.99','13.99','14.99','14.99','14.99','45.00','44.00','15.99','14.99','13.99','13.99','15.99'],
        beanIndex = jQuery('#beanIndex').val();

    switch (beanIndex) {
        case '0':
            jQuery('#subId').val(jQuery('.'+pId+'-Ground').val());
            jQuery('#coffeePrice').val(jQuery('.'+pId+'-Ground').data('price')); 
            break;
        case '1':
            beanIndex = 1;
            jQuery('#subId').val(jQuery('.'+pId+'-Whole').val());
            jQuery('#coffeePrice').val(jQuery('.'+pId+'-Whole').data('price')); 
            break;
        case '2':
            jQuery('#subId').val(jQuery('.'+pId+'-Pods').val());
            jQuery('#coffeePrice').val(jQuery('.'+pId+'-Pods').data('price')); 
            break;
    }

    /*
    console.log(productPosition);
    console.log(arrayCollection[productPosition][beanIndex]);*/
    //jQuery('#subId').val(arrayCollection[productPosition][beanIndex]);
    //console.log(arrayCollection[productPosition][beanIndex]);
}
  
function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type,  option) {
    data = {
        "quantity": quantity,
        "id": variant_id,
        "option-0": option,
        "properties[shipping_interval_frequency]": shipping_interval_frequency, 
        "properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
        "properties[subscription_id]": '152679'
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (response) {
            window.location.href = '/cart';
        },
        error: function (xhr, status, error) {
            var err = JSON.parse(xhr.responseText);
            alert('Product variant ID not found');
        }
    });
}
  
function showMealsDonation() {
    jQuery('.mealDiv img').hide();
    
    var mealCounter = 0,
        weekInterval = 0,
        qtyMealSelector = jQuery('#freqIndex').val();
    
    switch(qtyMealSelector) {
        case '0': weekInterval = 1; break;
        case '1': weekInterval = 2; break;
        case '2': weekInterval = 4; break;
        case '3': weekInterval = 8; break;
    }
    
    qtyMealSelector = 52/weekInterval;

    mealCounter = qtyMealSelector * jQuery('#qtyIndex').val() * 1.45 * 10;
    mealCounter = Math.round(mealCounter/100)*100;	  

    jQuery('.mealDiv p').attr('data-value',mealCounter);

    if(jQuery(window).width() > 980) {
      jQuery('.mealDiv .desktopMealImg'+mealCounter).show();	  
    } else {
      jQuery('.mealDiv .mobileMealImg'+mealCounter).show();	  
    }
}